import React from 'react';
import {Grid} from '@material-ui/core';
import './Dashboard.sass';

type LoadingDashboardCardProps = {
  title: string;
  iconName: string;
  subTitles: string[];
  id: string;
};

const LoadingDashboardCard = (props: LoadingDashboardCardProps) => {
  const {title, iconName, subTitles, id} = props;

  return (
    <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
      <div className="enrollment-dashboard__enrollment-file-card">
        <div className="enrollment-file-card">
          <div className="enrollment-file-card__title-container">
            <Grid container justify="space-between">
              <Grid item md={10} xs={9}>
                <div className="title-container--item">
                  <h3 id={`enrollment-file-card-title-${id}`} className="title-container--item-title">
                    {title}
                  </h3>
                </div>
              </Grid>
              <Grid item container md={2} xs={3} justify="flex-end">
                <div className={`title-container--item__icon-container ${iconName}`}>
                  <i className={`enrollment-file-card__icon icon--${iconName}`}></i>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="enrollment-file-card__statistics-container">
            {subTitles.map(subTitle => (
              <div key={subTitle} className="statistics-container--item three-stack">
                <h4 className="statistics-container--item-title">{subTitle}</h4>
                <p className="statistics-container--item-title">Loading...</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Grid>
  );
};

export default LoadingDashboardCard;
